import React from 'react';
import classNames from 'classnames';
import style from './style.module.scss';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { IProps } from './types';
import { makeStyles } from '@material-ui/core/styles';

const PlusMinusComponent = (props: IProps) => {

  const { handlePlusClick, handleMinusClick, plusDisabled, minusDisabled } = props;
  return (
    <div>
      <div className={classNames({
        [style.buttonContainer]: true,
        [style.disableBackground]: plusDisabled
      })}
        onClick={() => {
          if (!plusDisabled) {
            handlePlusClick();
          }
        }}
      >
        <AddIcon />
      </div>
      <div className={classNames({
        [style.buttonContainer]: true,
        [style.disableBackground]: minusDisabled,
        [style.borderForMinus]: true
      })}
        onClick={() => {
          if (!minusDisabled) {
            handleMinusClick();
          }
        }}
      >
        <RemoveIcon />
      </div>

    </div>
  );
};

export default PlusMinusComponent;
